module.exports = __webpack_public_path__ + "static/media/open_app_logo.2cb051cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/share/open_app_logo.png
// module id = 354
// module chunks = 150